import { Card, Col, Row, Statistic } from 'antd';
import styled from 'styled-components';

const Wrapper = styled.div`
  padding: 15px;
`;
export const HSMSStatistic = () => {
  return (
    <Wrapper>
      <Row gutter={16}>
        <Col span={12}>
          <Card>
            <Statistic title="Active" value={11.28} precision={2} valueStyle={{ color: '#3f8600' }} suffix="%" />
          </Card>
        </Col>
        <Col span={12}>
          <Card>
            <Statistic title="Idle" value={9.3} precision={2} valueStyle={{ color: '#cf1322' }} suffix="%" />
          </Card>
        </Col>
      </Row>
    </Wrapper>
  );
};
